const fields = {
    finalidade:'',
    tipo: '',
    endereco: '',
    imoveis: [],
    caracteristicas: [],
    caracsCondominio: [],
    total: '',
    loadingSideBar: true,
    loadingContent: true,
    data: [],
    tipos:[
        {
            'name': 'Selecione',
            'value': 0
        }
    ],
    bairros: [],
    cidades: [],
    order:'0',
    limit: 10,
    offset: 0,
    page: 1,
    filtros: {
        'valorInicial':'',
        'valorFinal':'',
        'areaInicial':'',
        'areaFinal':'',
        'quartos':'',
        'suites':'',
        'banheiros':'',
        'vagas':''
    },
    caracSelecionados:[],
    caracSelecionadosCondominio: []
};

export default fields;
